import React, { useState, useEffect } from "react";
import { Container, Box, Typography, Button, Paper } from "@mui/material";
import { ModeloGetUrlJson, ModeloUpdate, ModeloPost } from "../ModeloCrud";
import OrtodonciaFiltros from "./OrtodonciaFiltros";
import OrtodonciaTabla from "./OrtodonciaTabla";
import OrtodonciaLiquidacionesTabla from "./OrtodonciaLiquidacionesTabla";
import ApiService from "../../apis/ApiService";
import ModalConfirmation from "../modals/ModalConfirmation";
import ModalInformation from "../modals/ModalInformation";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SendIcon from "@mui/icons-material/Send";
import { LoadingButton } from "@mui/lab";

export default function ReporteLiquidacionOrtodoncia(props) {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [gastoBrackets, setGastoBrackets] = useState(null);
  const [porcentajePago, setPorcentajePago] = useState(null);
  const [formikValues, setFormikValues] = useState(null);
  const [exportando, setExportando] = useState(false);
  const [cerrando, setCerrando] = useState(false);
  const [enviandoMail, setEnviandoMail] = useState(false);
  const [enviandoMailId, setEnviandoMailId] = useState(null);
  const [modalConfirmMailOpen, setModalConfirmMailOpen] = useState(false);
  const [liquidacionParaMail, setLiquidacionParaMail] = useState(null);

  // Liquidación cerrada (modo individual)
  const [liquidacionCerrada, setLiquidacionCerrada] = useState(null);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  // Liquidaciones cerradas (modo listado — sin odontólogo)
  const [liquidaciones, setLiquidaciones] = useState([]);

  // Modales
  const [modalConfirmOpen, setModalConfirmOpen] = useState(false);
  const [modalInfoOpen, setModalInfoOpen] = useState(false);
  const [modalInfoMsg, setModalInfoMsg] = useState("");
  const [modalInfoTipo, setModalInfoTipo] = useState("info");
  const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);

  useEffect(() => {
    cargarParametros();
  }, []);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  async function cargarParametros() {
    const [resBrackets, resPorcentaje] = await Promise.all([
      ModeloGetUrlJson("tabla", null, "GASTOS_BRACKETS", null),
      ModeloGetUrlJson("tabla", null, "PORCENTAJE_PAGO_ORTODONCIA", null),
    ]);
    if (resBrackets.error === false && resBrackets.listado?.length > 0) {
      setGastoBrackets(resBrackets.listado[0]);
    }
    if (resPorcentaje.error === false && resPorcentaje.listado?.length > 0) {
      setPorcentajePago(resPorcentaje.listado[0]);
    }
  }

  async function handleActualizarParametro(parametro, nuevoValor) {
    const id = parametro.id;
    const result = await ModeloUpdate("tabla", id, { valor: nuevoValor });
    if (result.error === false) {
      if (parametro.codigo_tabla === "GASTOS_BRACKETS") {
        setGastoBrackets((prev) => ({ ...prev, valor: nuevoValor }));
      } else {
        setPorcentajePago((prev) => ({ ...prev, valor: nuevoValor }));
      }
    }
    return result;
  }

  async function handleBuscar(values) {
    setFormikValues(values);
    setReportData(null);
    setLiquidacionCerrada(null);
    setLiquidaciones([]);
    setMostrarTabla(false);

    let params =
      "fecha_desde=" +
      values.fecha_desde.format().slice(0, 10) +
      "&fecha_hasta=" +
      values.fecha_hasta.format().slice(0, 10) +
      "&centro_id=" +
      values.clinica.id;

    if (values.odontologo) {
      params += "&odontologo_id=" + values.odontologo.id;
    }

    setLoading(true);

    const [resultReporte, resultLiquidacion] = await Promise.all([
      values.odontologo
        ? ModeloGetUrlJson("ortodoncia", null, "prestaciones", params)
        : Promise.resolve({ error: false, data: null }),
      values.odontologo
        ? ModeloGetUrlJson(
            "liquidacion-ortodoncia/buscar",
            null,
            null,
            `centro_id=${values.clinica.id}&odontologo_id=${
              values.odontologo.id
            }&fecha_desde=${values.fecha_desde.format().slice(0, 10)}`,
          )
        : ModeloGetUrlJson(
            "liquidacion-ortodoncia/listar",
            null,
            null,
            `centro_id=${values.clinica.id}&fecha_desde=${values.fecha_desde
              .format()
              .slice(0, 10)}`,
          ),
    ]);

    setLoading(false);

    if (resultReporte.error === false) {
      setReportData(resultReporte.data);
    }

    if (values.odontologo) {
      if (
        resultLiquidacion?.error === false &&
        resultLiquidacion?.liquidacion
      ) {
        setLiquidacionCerrada(resultLiquidacion.liquidacion);
      }
    } else {
      if (resultLiquidacion?.error === false) {
        setLiquidaciones(resultLiquidacion.liquidaciones ?? []);
      }
    }
  }

  async function handleConfirmarMail() {
    setModalConfirmMailOpen(false);
    const liq = liquidacionParaMail ?? liquidacionCerrada;
    if (!liq) return;

    setEnviandoMailId(liq.id);
    setEnviandoMail(true);
    try {
      const result = await ModeloPost("ortodoncia/enviar-mail", null, null, {
        liquidacion_id: liq.id,
      });

      if (result?.error) {
        setModalInfoTipo("error");
        setModalInfoMsg(result.mensaje);
      } else {
        setModalInfoTipo("success");
        setModalInfoMsg("Mail enviado correctamente.");
      }
      setModalInfoOpen(true);
    } catch (e) {
      console.error("Error al enviar mail:", e);
      setModalInfoTipo("error");
      setModalInfoMsg("Error inesperado al enviar el mail.");
      setModalInfoOpen(true);
    } finally {
      setEnviandoMail(false);
      setEnviandoMailId(null);
      setLiquidacionParaMail(null);
    }
  }

  function handleEnviarMailDesdeTabla(liq) {
    setLiquidacionParaMail(liq);
    setModalConfirmMailOpen(true);
  }

  async function handleExportar() {
    if (!formikValues) return;
    setExportando(true);
    try {
      await ApiService.GetOrtodonciaExcel(
        formikValues.fecha_desde.format().slice(0, 10),
        formikValues.fecha_hasta.format().slice(0, 10),
        formikValues.clinica.id,
        formikValues.odontologo?.id ?? null,
        formikValues.clinica.razonsocial,
        formikValues.odontologo?.odontologo ?? null,
      );
    } catch (e) {
      console.error("Error al exportar Excel:", e);
    } finally {
      setExportando(false);
    }
  }

  function handleReliquidar() {
    setLiquidacionCerrada(null);
    setMostrarTabla(true);
  }

  function handleCerrarLiquidacion() {
    if (!formikValues) return;

    const input = document.createElement("input");
    input.type = "file";
    input.accept =
      ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    input.onchange = (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      setArchivoSeleccionado(file);
      setModalConfirmOpen(true);
    };

    input.click();
  }

  async function handleConfirmarCierre() {
    setModalConfirmOpen(false);
    if (!archivoSeleccionado) return;

    setCerrando(true);
    try {
      const base64 = await toBase64(archivoSeleccionado);

      const result = await ApiService.SubirLiquidacionOrtodoncia({
        archivo: base64,
        filename: archivoSeleccionado.name,
        centro_id: formikValues.clinica.id,
        odontologo_id: formikValues.odontologo?.id ?? null,
        fecha_desde: formikValues.fecha_desde.format().slice(0, 10),
      });

      if (result?.error) {
        const mensajes = result.errores
          ? result.errores.join("\n")
          : result.mensaje;
        setModalInfoTipo("error");
        setModalInfoMsg(mensajes);
        setModalInfoOpen(true);
      } else {
        setModalInfoTipo("success");
        setModalInfoMsg("Liquidación cerrada correctamente.");
        setModalInfoOpen(true);
        setLiquidacionCerrada(result.liquidacion);
        setMostrarTabla(false);
      }
    } catch (e) {
      console.error("Error al cerrar liquidación:", e);
      setModalInfoTipo("error");
      setModalInfoMsg("Error inesperado al cerrar la liquidación.");
      setModalInfoOpen(true);
    } finally {
      setCerrando(false);
      setArchivoSeleccionado(null);
    }
  }

  const periodoLabel = liquidacionCerrada
    ? `${String(liquidacionCerrada.periodo_mes).padStart(2, "0")}/${
        liquidacionCerrada.periodo_anio
      }`
    : "";

  return (
    <Container maxWidth="xl">
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6">Liquidación de Ortodoncia</Typography>
      </Box>

      <OrtodonciaFiltros
        onBuscar={handleBuscar}
        loading={loading}
        gastoBrackets={gastoBrackets}
        porcentajePago={porcentajePago}
        onActualizarParametro={handleActualizarParametro}
      />

      {/* Tabla de control — sin odontólogo seleccionado */}
      {!formikValues?.odontologo && formikValues && !loading && (
        <OrtodonciaLiquidacionesTabla
          liquidaciones={liquidaciones}
          onEnviarMail={handleEnviarMailDesdeTabla}
          enviandoMailId={enviandoMailId}
        />
      )}

      {/* Panel liquidación cerrada — con odontólogo seleccionado */}
      {liquidacionCerrada && (
        <Paper
          variant="outlined"
          sx={{
            mt: 2,
            mb: 2,
            p: 2,
            borderColor: "success.main",
            borderWidth: 1.5,
            borderRadius: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
            <CheckCircleOutlineIcon color="success" />
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                color="success.main"
              >
                Liquidación cerrada — {periodoLabel}
              </Typography>
              <Box sx={{ display: "flex", gap: 1, mt: 0.5, flexWrap: "wrap" }}>
                {liquidacionCerrada.odontologo && (
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      backgroundColor: "primary.main",
                      color: "white",
                      borderRadius: 10,
                      px: 1.5,
                      py: 0.3,
                    }}
                  >
                    <Typography variant="caption" fontWeight="bold">
                      {liquidacionCerrada.odontologo}
                    </Typography>
                  </Box>
                )}
                {liquidacionCerrada.email && (
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      backgroundColor: "grey.100",
                      color: "text.secondary",
                      borderRadius: 10,
                      px: 1.5,
                      py: 0.3,
                    }}
                  >
                    <Typography variant="caption">
                      {liquidacionCerrada.email}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            <Box sx={{ flex: 1 }} />
          </Box>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {liquidacionCerrada.url_excel && (
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                href={liquidacionCerrada.url_excel}
                target="_blank"
                sx={{
                  backgroundColor: "#1D6F42",
                  ":hover": { bgcolor: "#155534" },
                  textTransform: "none",
                }}
              >
                Descargar Excel
              </Button>
            )}
            {liquidacionCerrada.url_pdf && (
              <Button
                variant="contained"
                startIcon={<PictureAsPdfIcon />}
                onClick={() =>
                  window.open(
                    `${liquidacionCerrada.url_pdf}?t=${Date.now()}`,
                    "_blank",
                  )
                }
                sx={{
                  backgroundColor: "#C62828",
                  ":hover": { bgcolor: "#8e0000" },
                  textTransform: "none",
                }}
              >
                Descargar PDF
              </Button>
            )}
            {liquidacionCerrada.url_pdf && (
              <LoadingButton
                variant="contained"
                startIcon={<SendIcon />}
                loading={enviandoMail}
                loadingPosition="start"
                onClick={() => {
                  setLiquidacionParaMail(null);
                  setModalConfirmMailOpen(true);
                }}
                sx={{
                  backgroundColor: "#1565C0",
                  ":hover": { bgcolor: "#0d47a1" },
                  textTransform: "none",
                }}
              >
                Enviar por mail
              </LoadingButton>
            )}
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={handleReliquidar}
              sx={{
                textTransform: "none",
                color: "text.secondary",
                borderColor: "divider",
              }}
            >
              Reliquidar
            </Button>
          </Box>
        </Paper>
      )}

      {/* Tabla de prestaciones */}
      {(!liquidacionCerrada || mostrarTabla) && (
        <OrtodonciaTabla
          reportData={reportData}
          onExportar={reportData ? handleExportar : null}
          onCerrarLiquidacion={reportData ? handleCerrarLiquidacion : null}
          exportando={exportando}
          cerrando={cerrando}
        />
      )}

      <ModalConfirmation
        showModal={modalConfirmOpen}
        hideModal={() => setModalConfirmOpen(false)}
        confirmModal={handleConfirmarCierre}
        message="¿Confirmar cierre de liquidación? Esto reemplazará cualquier liquidación anterior del período."
      />

      <ModalInformation
        showModal={modalInfoOpen}
        hideModal={() => setModalInfoOpen(false)}
        message={modalInfoMsg}
        tipo={modalInfoTipo}
      />

      <ModalConfirmation
        showModal={modalConfirmMailOpen}
        hideModal={() => setModalConfirmMailOpen(false)}
        confirmModal={handleConfirmarMail}
        message="¿Confirmar envío de liquidación por mail al odontólogo?"
      />
    </Container>
  );
}
